import React from 'react';
import { toggleModal } from "../reducers/content";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

const AboutModal = (props) => {
	if(!props.content.showAboutModal)
		return null

	return (
		<React.Fragment>
			<div onClick={() => props.toggleModal('about')} className="the-modal-overlay" />

			<div className="the-modal">
				<div className="fancybox-content">
					<h2 data-selectable="true">About Cynet</h2>
					<div className="text mt-4" data-selectable="true">
						<h3>The Platform of Choice for Incident Response</h3>
						<p>The Cynet 360 platform provides incident responders with an enterprise grade visibility into the entire environment's endpoints, process execution, network traffic and user activity. Rapid and seamless agent distribution across thousands of endpoints in mere minutes empowers IR professionals to have the immediate visibility that's required in the initial investigation steps to gain insight into the incident's scope.</p>
						<p>Cynet 360 can also be used as a mass distribution platform for any open source tool, enabling responders to focus on their investigative expertise without wasting time and efforts on repetitive IT deployment tasks.</p>
						<p><a rel={'noopener noreferrer'} target={'_blank'} href="https://www.cynet.com/partners/free-incident-response/?utm_source=irchallenge">Learn more about Cynet for Incident Responders</a></p>
					</div>

					<div className="text-right mb-3 mb-sm-0">
						<button onClick={() => props.toggleModal('about')} className="btn-blue_light bold btn-hover text-center sign-up mt-3 ml-auto">GOT IT</button>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

function mapStateToProps(state) {
	return {content: state.content};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	toggleModal
}, dispatch)

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AboutModal);